import { photosMapper, videosMapper } from './mappers';
import { IFotoramaData } from '../../../typings/fotorama';
import { IState } from '../../store';
import { getPhotos, getVideos } from '../../utils/gallery_helpers';

export function getSlides(state: IState): IFotoramaData[] {
  const photos = getPhotos(state).map(photosMapper);
  const videos = getVideos(state).map(videosMapper);

  return [...photos, ...videos] as IFotoramaData[];
}
